module.exports = __webpack_public_path__ + "static/media/learn.90f96307.gif";